export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 100;

export type NewPasswordError = "required" | "min_length" | "max_length" | "same_as_current";
export type ConfirmPasswordError = "required" | "mismatch";

/** Espelha as regras do DTO de `/auth/change-password` para a nova senha. */
export function newPasswordError(password: string, currentPassword: string): NewPasswordError | null {
  if (!password) {
    return "required";
  }

  if (password.length < PASSWORD_MIN_LENGTH) {
    return "min_length";
  }

  if (password.length > PASSWORD_MAX_LENGTH) {
    return "max_length";
  }

  if (currentPassword && password === currentPassword) {
    return "same_as_current";
  }

  return null;
}

/** A confirmação é validada só no front e não vai para a API. */
export function confirmPasswordError(confirm: string, password: string): ConfirmPasswordError | null {
  if (!confirm) {
    return "required";
  }

  return confirm === password ? null : "mismatch";
}
